import { useState } from "react";
import {
  Typography,
  IconButton,
  Box,
  Grid,
  // Button,
  Tooltip,
} from "@material-ui/core";
import useStyle, {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "./styles";
import { Icons } from "components/Icons";
// import { useFormatPhone } from "hooks";
// import { convertDateAndTime } from "utils";
import { AddreeseeDetails } from "components";

type AccordionItemProps = {
  data: any;
  index: number;
  editUser?: any;
  deleteUser?: any;
  // isOpen: any;
  cardOpen?: any;
};

// type ModalInfoProps = {
//   title: string;
//   text: any;
//   type: string;
//   objToSend: {
//     name: string;
//     phone: string;
//     acessible: boolean;
//     receiveOnRegularBox: boolean;
//   };
// };

export const AccordionItem = ({
  data,
  cardOpen,
  // isOpen,
  index,
  editUser,
  deleteUser,
  ...rest
}: AccordionItemProps) => {
  // const { formatPhone } = useFormatPhone();
  const classes = useStyle();
  const [toggle, setToggle] = useState(true);
  const [openDetails, setOpenDetails] = useState(false);

  // const copyButton = (text: any) => {
  //   clipboardCopy(text);
  //   toast.success("Senha copiada");
  // };

  return (
    <>
      <Accordion
        {...rest}
        square
        expanded={toggle}
        onChange={() => setToggle(!toggle)}
      >
        <AccordionSummary
          expandIcon={<Icons.ExpandMore fontSize="large" />}
          aria-controls={`panel-content-${index}`}
          id={`panel-header-${index}`}
        >
          <Grid className={classes.summaryContainer}>
            <div className={classes.divSummary}>
              <Typography
                className={classes.bookingDate}
                style={{ minWidth: "100px" }}
              >
                <div style={{ fontWeight: "bold" }}>Nome</div>
                <div style={{ color: "var(--grayLv3)", fontWeight: 500 }}>
                  {data?.NMUSUARIO}
                </div>
              </Typography>
              <Typography className={classes.bookingDate}>
                <div style={{ fontWeight: "bold" }}>Tel. Celular</div>
                <div style={{ color: "var(--grayLv3)", fontWeight: 500 }}>
                  {data?.TELEFONE}
                </div>
              </Typography>
              <Typography className={classes.bookingDate}>
                <div style={{ fontWeight: "bold" }}>Grupo</div>
                <div style={{ color: "var(--grayLv3)", fontWeight: 500 }}>
                  {data?.GRUPOUSUARIO[0]?.FLUSERADM === 0
                    ? "Destinatário"
                    : "Administrador"}
                </div>
              </Typography>
            </div>
          </Grid>
        </AccordionSummary>
        <AccordionDetails className={classes.divDetails}>
          <Grid style={{ display: "flex", flexDirection: "column" }}>
            <div className={classes.divBottom}>
              <Typography className={classes.modulocker}>
                <div style={{ fontWeight: 700, color: "var(--black)" }}>ID</div>
                <div
                  style={{
                    color: "rgb(97, 97, 97)",
                    fontWeight: 500,
                  }}
                >
                  {data?.IDUSUARIO}
                </div>
              </Typography>
              {/* <Typography
                className={classes.modulocker}
                style={{ minWidth: "150px", maxWidth: "150px" }}
              >
                <div style={{ fontWeight: 700, color: "var(--black)" }}>
                  Data do cadastro
                </div>
                <div
                  style={{
                    color: "var(--grayLv3)",
                    display: "flex",
                    fontWeight: 500,
                  }}
                >
                
                  -
                </div>
              </Typography> */}
              {/* <Typography
                className={classes.modulocker}
                style={{ minWidth: "200px" }}
              >
                <div style={{ fontWeight: 700, color: "var(--black)" }}>
                  Data da atualização
                </div>
                <div style={{ color: "rgb(97, 97, 97)", fontWeight: 500 }}>
                 
                  {convertDateAndTime(data?.DTUPDATE)}
                </div>
              </Typography> */}
              <Typography className={classes.modulocker}>
                <div style={{ fontWeight: 700, color: "var(--black)" }}>
                  Complemento
                </div>
                <div
                  style={{
                    color: "rgb(97, 97, 97)",
                    fontWeight: 500,
                  }}
                >
                  {data?.ENDECOMPL}
                </div>
              </Typography>
            </div>

            {/* acessibilidade */}
            <div style={{ marginTop: 20, display: "flex", flexWrap: "wrap" }}>
              <Typography className={classes.modulocker}>
                <div style={{ fontWeight: 700, color: "var(--black)" }}>
                  Utiliza box acessível?
                  <span
                    style={{
                      color: "rgb(97, 97, 97)",
                      fontWeight: 500,
                      marginLeft: 10,
                    }}
                  >
                    {data?.FLCADEIRANTE ? "Sim" : "Não"}
                  </span>
                </div>
              </Typography>
              <Typography className={classes.acessibleBox}>
                <div>
                  Na ausência de box acessível utilizar box comum?
                  <span
                    style={{
                      color: "rgb(97, 97, 97)",

                      fontWeight: 500,
                      marginLeft: 10,
                    }}
                  >
                    {data?.FLRECEIVEINCOMMONBOXES ? "Sim" : "Não"}
                  </span>
                </div>
              </Typography>
            </div>
          </Grid>
          <Box
            style={{
              width: "100%",
              height: 50,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <IconButton
              style={{
                color: "#ff6500",
              }}
              onClick={() => setOpenDetails(true)}
            >
              <Tooltip title="INFORMAÇÕES" placement="left">
                <Icons.Info fontSize="large" />
              </Tooltip>
            </IconButton>
          </Box>
        </AccordionDetails>
      </Accordion>
      <AddreeseeDetails
        order={data}
        open={openDetails}
        setOpen={setOpenDetails}
      />
    </>
  );
};
